{
  "welcome": "Bienvenido a",
  "instructions": "Toca abajo para comenzar tu proceso de registro.",
  "startCheckIn": "Iniciar registro",
  "missingWarehouseTitle": "Almacén faltante",
  "missingWarehouseMessage": "El enlace es inválido, debe contener el ID del almacén",
  "recaptchaAttribution": "Este sitio está protegido por reCAPTCHA y se aplican la {privacyPolicy} y los {termsOfService} de Google.",
  "recaptchaPrivacyPolicy": "Política de privacidad",
  "recaptchaTermsOfService": "Términos del servicio",
  "lookupTitle": "Agrega el número de referencia o de confirmación para encontrar tu cita",
  "referenceNumberLabel": "Número de referencia o número de confirmación",
  "referenceNotFoundError": "El número de referencia o de confirmación no coincide con ninguna cita válida.",
  "checkIn": "Registrarse",
  "loadTypeLabel": "Tipo de carga",
  "directionLabel": "Dirección",
  "operationLabel": "Operación",
  "dockLabel": "Muelle",
  "orDivider": "o",
  "noReferenceTitle": "No tengo un número de confirmación",
  "noReferenceDescription": "Continúa sin una cita utilizando el proceso de registro estándar.",
  "checkInWithoutAppointment": "Registrarse sin cita",
  "readyToCheckInTitle": "¿Listo para hacer check-in?",
  "readyToCheckInDescription": "Toca abajo para comenzar. Ingresarás tus datos en la siguiente pantalla.",
  "referenceRequiredHint": "Se requiere un número de referencia para hacer check-in en esta ubicación.",
  "haveAppointment": "Tengo una cita",
  "direction": {
    "inbound": "Entrante",
    "outbound": "Saliente",
    "inOut": "Entrante y saliente",
    "load": "Carga",
    "unload": "Descarga"
  },
  "operation": {
    "live": "En vivo",
    "drop": "Drop",
    "other": "Otra"
  }
}
